import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

const parseDateFromText = (date) => {
    var newDate = moment(date).format('Do MMMM YYYY')
    return newDate
}
const parseTimeFromText = (date) => {
    var newDate = moment(date).format('HH:mm')
    return newDate
}

export { parseDateFromText,parseTimeFromText }